/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@keyframes spin{from{transform:rotate(0)}to{transform:rotate(359deg)}}@-webkit-keyframes spin{from{transform:rotate(0)}to{transform:rotate(359deg)}}.redirect-text[_ngcontent-%COMP%]{opacity:50%;font-style:italic;margin-top:30px}.sub-description[_ngcontent-%COMP%]{line-height:1.4}.description[_ngcontent-%COMP%]{line-height:1.8}.description[_ngcontent-%COMP%]     a{color:#79b7ff;font-weight:700}"];
export { styles as styles };
